import DarkTheme from "./dark";
import LightTheme from "./light";
export enum ThemeType {
  Light = "light",
  Dark = "dark",
}
const clientTheme = {
  [ThemeType.Light]: {
    name: ThemeType.Light,
    ...LightTheme,
  },

  [ThemeType.Dark]: {
    name: ThemeType.Dark,
    ...DarkTheme,
  },
};
export default clientTheme;
